import { render, staticRenderFns } from "./TimerAlert.vue?vue&type=template&id=6150cd70"
import script from "./TimerAlert.vue?vue&type=script&lang=js"
export * from "./TimerAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports